export const tooltipInternalDelay = 500
